import type { KeksmeisterTranslations } from '../core/types.js';

export const de: KeksmeisterTranslations = {
  banner: {
    title: 'Cookie-Einstellungen',
    description:
      'Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. Einige Cookies sind für den Betrieb der Seite notwendig, andere helfen uns, die Seite zu verbessern und Ihnen relevante Inhalte anzuzeigen.',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    settings: 'Einstellungen',
    closeReject: 'Schließen und alle Cookies ablehnen',
    closeRejectHint: 'Schließen dieses Banners gilt als Ablehnung.',
  },
  modal: {
    title: 'Cookie-Einstellungen',
    description:
      'Hier können Sie detailliert auswählen, welche Cookies Sie zulassen möchten. Notwendige Cookies können nicht deaktiviert werden, da sie für den Betrieb der Website erforderlich sind.',
    save: 'Auswahl speichern',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    alwaysActive: 'Immer aktiv',
    close: 'Schließen',
  },
  privacyLink: 'Datenschutzerklärung',
  trigger: { label: 'Cookie-Einstellungen' },
  categories: {
    essential: {
      label: 'Notwendig',
      description:
        'Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und können nicht deaktiviert werden.',
    },
    functional: {
      label: 'Funktional',
      description:
        'Diese Cookies ermöglichen erweiterte Funktionen und Personalisierung, z.B. Spracheinstellungen.',
    },
    analytics: {
      label: 'Analyse',
      description:
        'Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren, und ermöglichen uns, die Nutzererfahrung zu verbessern.',
    },
    marketing: {
      label: 'Marketing',
      description:
        'Diese Cookies werden verwendet, um Besuchern relevante Werbung und Marketingkampagnen anzuzeigen.',
    },
  },
};
